// extracted by mini-css-extract-plugin
module.exports = {"background":"bd_dC","shopping__wrapper__examples":"bd_d0","active":"bd_d1","shopping__wrapper__project":"bd_d2"};